import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Waveform } from "@phosphor-icons/react";
import GoogleAuthButton from "@/components/GoogleAuthButton";

const Login = () => {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Bienvenue ${u.full_name} !`);
      const target = u.role === "admin" ? "/admin" : u.role === "artist" ? "/dashboard" : "/concerts";
      const to = loc.state?.from || target;
      nav(to);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Connexion impossible");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 mb-10 justify-center">
          <Waveform weight="fill" size={28} className="text-[#E11D48]" />
          <span className="font-display font-black text-2xl">XooKmédia</span>
        </Link>

        <div className="bg-[#0f0f10] border border-white/10 rounded-2xl p-8">
          <h1 className="font-display font-black text-3xl mb-2">Reconnectez-vous</h1>
          <p className="text-zinc-400 text-sm mb-8">Retrouvez votre scène et vos fans.</p>

          <form onSubmit={submit} className="space-y-5">
            <div>
              <Label htmlFor="email" className="text-zinc-300">Email</Label>
              <Input data-testid="login-email" id="email" type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-2 bg-black/40 border-white/10 text-white" />
            </div>
            <div>
              <div className="flex items-center justify-between">
                <Label htmlFor="password" className="text-zinc-300">Mot de passe</Label>
                <Link to="/forgot-password" data-testid="login-forgot" className="text-xs text-[#F59E0B] hover:text-white">
                  Mot de passe oublié ?
                </Link>
              </div>
              <Input data-testid="login-password" id="password" type="password" required value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-2 bg-black/40 border-white/10 text-white" />
            </div>
            <Button data-testid="login-submit" type="submit" disabled={loading}
              className="w-full bg-[#E11D48] hover:bg-[#BE123C] text-white">
              {loading ? "Connexion..." : "Se connecter"}
            </Button>
          </form>

          <div className="my-5 flex items-center gap-3">
            <div className="flex-1 h-px bg-white/10" />
            <span className="text-xs uppercase tracking-widest text-zinc-500">ou</span>
            <div className="flex-1 h-px bg-white/10" />
          </div>

          <GoogleAuthButton role="fan" label="Continuer avec Google" testId="login-google" />

          <p className="mt-6 text-center text-sm text-zinc-400">
            Nouveau ?{" "}
            <Link to="/signup" className="text-[#E11D48] hover:text-[#F59E0B]" data-testid="login-link-signup">Créer un compte</Link>
          </p>
          <div className="mt-6 p-3 rounded-lg bg-black/40 border border-white/5 text-xs text-zinc-500 font-mono">
            Démo artiste: <span className="text-white">artist@xookmedia.com / Artist2026!</span><br/>
            Démo fan: <span className="text-white">fan@xookmedia.com / Fan2026!</span><br/>
            Admin: <span className="text-white">admin@xookmedia.com / Admin2026!</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
